import { Meta } from "./Meta";
import { Empty } from "../cutil/Empty";
export class TryResult {
    constructor(data, error) {
        this.data = data;
        this.error = error;
        if (data === undefined && error === undefined) {
            throw new Meta("CannotAllUndefined", "Cannot be all undefined");
        }
    }
}
export async function tryPromise(promise) {
    try {
        const data = (await promise) ?? Empty.value;
        return new TryResult(data, undefined);
    }
    catch (error) {
        return new TryResult(undefined, error);
    }
}
export function tryBlock(block) {
    try {
        const data = block() ?? Empty.value;
        return new TryResult(data, undefined);
    }
    catch (error) {
        return new TryResult(undefined, error);
    }
}
export async function retryPromise(promise, retryCount = 1) {
    try {
        const data = (await promise) ?? Empty.value;
        return new TryResult(data, undefined);
    }
    catch (error) {
        if (retryCount <= 0) {
            return new TryResult(undefined, error);
        }
        return retryPromise(promise, retryCount - 1);
    }
}
